export default "/fonts/poppins-v9-latin-regular.eot?4747bd2214b475fbb299cc0a8eceeb6b";